module.exports = __webpack_public_path__ + "static/img/casino-top-bg-PC.eb8c1aa.jpg";